import NavBar from "../../screens/NavBar/NavBar";
import Invoices from "../Invoices";
import React, { useEffect } from "react";
import TriggerActionService from "../../components/TriggerActionService";
import ActionTriggerConstants from "../../components/ActionTriggerConstants";

const Dashboard = () => {
    useEffect(() => {
        // Fire-and-forget async trigger action
        TriggerActionService.sendTriggerAction(ActionTriggerConstants.LANDING_OPEN, "", {
            sourceUrl: "Dashboard"
        }).catch((e) => {
            console.warn("[-] TriggerActionService failed", e);
        });
    }, []);

    // Invoices renders itself inside a DataPage, which owns the scrolling and the centering.
    return (
        <React.Fragment>
            <NavBar />
            <Invoices hasNavBar />
        </React.Fragment>
    );
};

export default Dashboard;
